module.exports = __webpack_public_path__ + "img/bookcover.549b1d6e.jpg";